import { createUserScopedStorageAtom } from '@heidi/utils/jotai-storage';

/** Must match the Rust `HardwareMicTriggerMode` wire values (pinned by a Rust test). */
export type DictaphoneTriggerMode = 'double_press' | 'single_press';

export const DEFAULT_DICTAPHONE_TRIGGER_MODE: DictaphoneTriggerMode = 'double_press';

/**
 * v2: the v1 key held the retired `press_and_hold` / `hands_free` choice,
 * whose hands-free option disabled hold-to-speak. It shipped only behind the
 * device-setup flag and before a tagged release, so v1 choices fall back to
 * the default rather than migrate; the logout sweep removes the stale blobs.
 */
export const DICTAPHONE_TRIGGER_MODE_STORAGE_KEY =
  'heidi.dictate.dictaphoneTriggerMode:v2';

/**
 * How a quick press of the dictaphone start/stop button enters hands-free, for
 * every connected device: a double press (like the keyboard shortcut) or a
 * single press, after which the next press stops. Holding the button records
 * until release in both modes. The keyboard shortcut is unaffected. Persisted
 * per user; synced to Rust by the app shell.
 */
export const dictaphoneTriggerModeAtom =
  createUserScopedStorageAtom<DictaphoneTriggerMode>(
    DICTAPHONE_TRIGGER_MODE_STORAGE_KEY,
    DEFAULT_DICTAPHONE_TRIGGER_MODE
  );
